import ContactUsForm from "../components/ContactUsForm";
import ContactUsHeader from "../components/ContactUsHeader";

const ContactUs = () => {
    return (
        <>
            <ContactUsHeader />
            <ContactUsForm />
        </>
    )
}

export default ContactUs;